import appConfig from '../config/app'
const BASE_URL = appConfig.apiPath

function callApi(endpoint, config = {}) {
  let baseConfig = {
    mode: 'cors',
    headers: {
      'Accept': 'application/json',
      'Content-Type' : 'application/json'
    },
  }

  return fetch(BASE_URL + endpoint, Object.assign(baseConfig, config))
    .then(response =>
      response.json()
        .then(data => ({ data, response }))
    ).then(({ data, response }) => {
      if (!response.ok) {
        Promise.reject(data);
        return { 'ok': false, 'data': data }
      }
      else {
        return { 'ok': true, 'data': data }
      }
    }).catch(err => console.log("Error: ", err))
}

export const CALL_API = Symbol('Call API');

export default store => next => action => {
  const callAPI = action[CALL_API]

  if(typeof callAPI === 'undefined') {
    return next(action)
  }

  let { endpoint, config, types } = callAPI
  const [requestType, successType, errorType] = types

  var creds = ''
  if (config.body) {
    creds = JSON.parse(config.body)
  }  

  next({type: requestType, creds: creds})

  return callApi(endpoint, config).then((response) => {
    let data = response.data
    if(!response.ok) {
      next({
        error: data.message || 'Error',
        type: errorType
      })
    }
    else {
      next({
        data,
        success: data.message || 'Success',
        type: successType
      })      
    }
  }, (error) => {
    next({
      error: error.message || 'Critical Error!',
      type: errorType
    })    
  })
}


// WEBPACK FOOTER //
// ./src/middleware/api.js